document.addEventListener('DOMContentLoaded', function() {
    // Inicializando los eventos para los botones y otros elementos del formulario
    initialEventsToElementsByClass( 'btn-next-element-form', 'click', nextElementForm );
    
    initialEventsToElementsByClass( 'btn-back-element-form', 'click', backElementForm );

    initalEventToElementById( 'btn-show-pass', 'click', toogleShowPass, 'password' );
    
    initalEventToElementById( 'btn-show-pass-confirm', 'click', toogleShowPass, 'password_confirmation' );
});

function initialEventsToElementsByClass( nameClass, nameEvent, callback, paramCallback = null )
{
    const buttonNextElementForm = document.getElementsByClassName(nameClass);

    if( buttonNextElementForm.length )
    for (let index = 0; index < buttonNextElementForm.length; index++) {
        const element = buttonNextElementForm[index];
        
        // element.addEventListener(nameEvent, callback);
        setEventListenerToElement( element, nameEvent, callback );
    }
}

function initalEventToElementById( nameById, nameEvent, callback, paramCallback = null )
{
    const item = document.getElementById( nameById );

    if( item )
    setEventListenerToElement( item, nameEvent, function() {
        callback( paramCallback );
    });
}

function setEventListenerToElement( element, nameEvent, callback ){
    element.addEventListener(nameEvent, callback);
}

function toogleShowPass(inputId) {
    let input = $("#" + inputId);

    if (input) {
        if (input.data("show") == 'true') {
            input.attr("type", "password");
            input.data("show", "");
            input.parent().find("div > button.showPass > i").removeClass('mdi-eye-off');
            input.parent().find("div > button.showPass > i").addClass('mdi-eye');

        } else {
            input.attr("type", "text");
            input.data("show", "true");
            input.parent().find("div > button.showPass > i").removeClass('mdi-eye');
            input.parent().find("div > button.showPass > i").addClass('mdi-eye-off');
        }
    }
}

let position = 1;
const minPosition = 1;
const maxPosition = 6;
function nextElementForm() {
    if (position < minPosition || position > maxPosition) {
        resetForm();
    }

    if (!validationsForm())
        return;

    if (position > ( minPosition - 1 ) && position < ( maxPosition + 1 ) ) {

        if ((position + 1) > maxPosition) {
            const form = document.getElementById('form-register');
            form.submit();

        } else {
            hideElements();
            showElement(++position);
            if (position == maxPosition) {
                document.getElementById('submitButton').disabled = false;
            }

        }

    }
}

function backElementForm() {
    if (position < minPosition || position > maxPosition) {
        resetForm();
    }

    position = (position - 1) < minPosition ? minPosition : (position - 1);

    hideElements();
    showElement(position);
}

function hideElements() {
    $(".form-sections").hide();
}

function showElement(currentPosition) {
    $(".form-section-" + currentPosition).fadeIn();
}

function resetForm() {
    position = 1;
    hideElements();
    showElement(position);
}

function validationsForm() {
    // Nombre del cliente
    if (position == 1) {
        const input = document.getElementById('name_client');
        const span = document.getElementById('name_client_span');
        span.innerHTML = '';

        input.value = input.value.trim();

        if (input.value == '') {
            span.innerHTML = 'El campo nombre no puede estar vacío.';
        }

        if (input.value.length > 80) {
            span.innerHTML = 'No puede superar los 80 caracteres.';
        }

        if (span.innerHTML != '')
        return false;
    }

    // Cargo del cliente
    if ( position == 2 ) {
        const input = document.getElementById('job_client');
        const span = document.getElementById('job_client_span');
        span.innerHTML = '';

        input.value = input.value.trim();

        if (input.value == '') {
            span.innerHTML = 'El campo del cargo no puede estar vacío.';
        }

        if (input.value.length > 150) {
            span.innerHTML = 'No puede superar los 150 caracteres.';
        }

        if (span.innerHTML != '')
        return false;
    }

    // Email
    if (position == 3) {
        const input = document.getElementById('email');
        const span = document.getElementById('email_span');
        span.innerHTML = '';

        input.value = input.value.trim();

        if (input.value == '') {
            span.innerHTML = 'El campo email no puede estar vacío.';
        }

        if (input.value.length > 45) {
            span.innerHTML = 'No puede superar los 45 caracteres.';
        }

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.exec(input.value) === null) {
            span.innerHTML = 'Formato del email no es valido.';
        }

        if (span.innerHTML != '')
            return false;
    }

    // Telefono del cliente
    if ( position == 4 ) {
        const input = document.getElementById('phone_client');
        const span = document.getElementById('phone_client_span');
        span.innerHTML = '';

        input.value = input.value.trim();

        if (input.value == '') {
            span.innerHTML = 'El campo del cargo no puede estar vacío.';
        }

        if (input.value.length > 14) {
            span.innerHTML = 'No puede superar los 14 caracteres.';
        }

        if (/^(\+[0-9]{1,2})?[0-9]{9,11}$/.exec(input.value) === null) {
            span.innerHTML = 'Formato del telefono no es valido';
        }

        if (span.innerHTML != '')
        return false;
    }    

    // Contraseña
    if (position == 5) {
        const input = document.getElementById('password');
        const input2 = document.getElementById('password_confirmation');
        const span = document.getElementById('password_span');
        span.innerHTML = '';

        if (input.value == '') {
            span.innerHTML = 'El campo password no puede estar vacío.';
            return false;
        }

        if (input.value.length < 8) {
            span.innerHTML = 'No puede ser menor a los 8 caracteres.';
            return false;
        }

        if (input.value.length > 45) {
            span.innerHTML = 'No puede superar los 26 caracteres.';
            return false;
        }

        if (input.value != input2.value) {
            span.innerHTML = 'Las contraseñas no coinciden.';
            return false;
        }
    }

    // Politicas, Terminos y Condiciones
    if (position == 6) {
        const input = document.getElementById('terms');
        const span = document.getElementById('terms_span');
        span.innerHTML = '';

        if ($("#terms:checked").val() != 'on') {
            span.innerHTML = 'Debe aceptar los terminos de servicio y politicas de privacidad.';
            return false;
        }
    }

    return true;
}